import cornerstone from 'cornerstone-core';
import cornerstoneTools from 'cornerstone-tools';

const MIN_ROTATION_RADIUS_RATIO = 0.1;
const MIN_ROTATION_RADIUS_PIXELS = 24;

class RotateTool extends cornerstoneTools.RotateTool {
  postMouseDownCallback(evt) {
    this.initialRotation = evt.detail.viewport.rotation;
  }

  mouseDragCallback(evt) {
    this.dragCallback(evt);
  }

  touchDragCallback(evt) {
    this.dragCallback(evt);
  }

  dragCallback(evt) {
    const { element, viewport, startPoints, currentPoints } = evt.detail;
    const { rotateScale = 1 } = this.configuration;
    const rect = element.getBoundingClientRect();
    const width = element.clientWidth;
    const height = element.clientHeight;
    const { scale, translation } = viewport;
    const center = {
      x: rect.left + width / 2 + translation.x * scale,
      y: rect.top + height / 2 + translation.y * scale,
    };
    const startX = startPoints.client.x - center.x;
    const startY = startPoints.client.y - center.y;
    const currentX = currentPoints.client.x - center.x;
    const currentY = currentPoints.client.y - center.y;
    const startRadius = Math.hypot(startX, startY);
    const minRadius = Math.max(
      MIN_ROTATION_RADIUS_PIXELS,
      Math.min(width, height) * MIN_ROTATION_RADIUS_RATIO
    );

    let angle;
    if (startRadius < 1) {
      // The radial angle is undefined at the image center. Use a small,
      // predictable horizontal response there instead of producing a jump.
      angle = (currentPoints.client.x - startPoints.client.x) / minRadius;
    } else {
      const cross = startX * currentY - startY * currentX;
      const dot = startX * currentX + startY * currentY;
      angle = Math.atan2(cross, dot);

      // Reduce sensitivity for drags close to the center, where the same
      // pointer movement otherwise sweeps through a much larger angle.
      if (startRadius < minRadius) {
        angle *= startRadius / minRadius;
      }
    }

    viewport.initialRotation = this.initialRotation;
    viewport.rotation = this.initialRotation + angle * (180 / Math.PI) * rotateScale;
    cornerstone.setViewport(element, viewport);
  }
}

export default RotateTool;
